import { useEffect } from 'react'

/**
 * Ferme une modale avec la touche Echap.
 *
 * @param active  true quand la modale est ouverte
 * @param onClose appele a l'appui sur Echap
 */
export function useEscapeKey(active: boolean, onClose: () => void) {
  useEffect(() => {
    if (!active) return
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [active, onClose])
}
